import {Form, Typography} from "@bezlimit/bezlimit-ui";
import {FormInstance, FormItemProps, Input} from "antd";
import {useEffect, useRef, useState} from "react";
import _, {isNil} from "lodash";
import {useTranslation} from "react-i18next";
import "./style.scss";
import PhonesFiltersService from "../../../services/PhonesFiltersService";
import {observer} from "mobx-react";
import NumbersFiltersStoreService from "../../../services/NumbersFiltersStoreService";

export default observer(function SmartField({
    formInstance,
    props,
    phoneCombs,
    setPhoneCombs,
    currentCheckbox,
    setShouldUpdate
}: IProps) {
    const ref = useRef(null);
    const {t} = useTranslation();
    const [value, setValue] = useState("");

    const onKeyUp = (e: any) => {
        let next = _.replace(e.target.value.toString(), /(\+7|\D)/gm, "");
        if (_.size(next) > 10) {
            next = next.slice(0, 10);
        }

        const fields = formInstance.getFieldsValue();
        fields["phone_combs"] = next;
        formInstance.setFieldsValue(fields);
        setPhoneCombs(next);
        setValue(next);

        let values = _.clone(PhonesFiltersService.currentFilter);
        values.phone_combs = next;
        PhonesFiltersService.setCurrentFilter(values);

        if (_.isNil(currentCheckbox) && !isNil(setShouldUpdate)) {
            if (
                _.isNil(NumbersFiltersStoreService.current) &&
                !!PhonesFiltersService.currentFilter.phone_combs?.replace(/,/gi, "")
            ) {
                setShouldUpdate(true);
            } else {
                setShouldUpdate(false);
            }
        }
    };

    const onKeyDown = (e: any) => {
        if (
            (_.inRange(e.keyCode, 48, 58) && !e.shiftKey) ||
            _.isEqual(e.keyCode, 8) ||
            (_.inRange(e.keyCode, 96, 106) && !e.shiftKey) ||
            (_.isEqual(e.keyCode, 86) && e.ctrlKey) ||
            (_.isEqual(e.keyCode, 86) && e.metaKey)
        ) {
        } else {
            e.preventDefault();
        }
    };

    const onPaste = (e: any) => {
        e.preventDefault();

        let next = _.replace(e.clipboardData.getData("text/plain"), /(\+7|^8|\D)/gm, "");
        if (_.size(next) > 10) {
            next = next.slice(0, 10);
        }
        e.target.value = next;
        onKeyUp(e);
    };

    useEffect(() => {
        const initial = _.replace(phoneCombs ?? "", /,/gi, "");
        setValue(initial);
        const fields = formInstance.getFieldsValue();
        fields["phone_combs"] = initial;
        formInstance.setFieldsValue(fields);
    }, [phoneCombs]);

    return (
        <div ref={ref}>
            <Typography as="div" className="bl-smart-field">
                <Input
                    className="input_0"
                    onChange={onKeyUp}
                    onKeyDown={onKeyDown}
                    onPaste={onPaste}
                    value={value}
                    placeholder={t("Поиск по комбинации в любой части номера")}
                />
                <Form.Item {...props} hidden className="field-phone_combs" name="phone_combs">
                    <Input autoComplete="new-phone_combs" />
                </Form.Item>
            </Typography>
        </div>
    );
});

interface IProps {
    formInstance: FormInstance<any>;
    props?: FormItemProps<any>;
    phoneCombs: string | undefined;
    setPhoneCombs: React.Dispatch<React.SetStateAction<string | undefined>>;
    currentCheckbox?: number | undefined;
    setShouldUpdate?: React.Dispatch<React.SetStateAction<boolean>>;
}
